export const WHATSAPP_NUMBER = "5573988068321";
export const WHATSAPP_FORMATTED = "(73) 98806-8321";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const DOMAIN = "hbsolarenergia.com.br";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1721786031430-29d464a0d4ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMHNvbGFyJTIwcG93ZXIlMjBncmVlbiUyMG5hdHVyZXxlbnwwfHx8fDE3ODg4OTEyODV8MA&ixlib=rb-4.1.0&q=85",
  installation:
    "https://images.unsplash.com/photo-1655300256335-beef51a914fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxlbmdpbmVlciUyMHNvbGFyJTIwZW5lcmd5JTIwcm9vZnxlbnwwfHx8fDE3ODg4OTEyOTZ8MA&ixlib=rb-4.1.0&q=85",
  panelsCloseUp:
    "https://images.unsplash.com/photo-1724994727393-1040b798a228?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsJTIwcm9vZiUyMHNreXxlbnwwfHx8fDE3ODg4OTEyOTZ8MA&ixlib=rb-4.1.0&q=85",
  commercial:
    "https://images.unsplash.com/photo-1694327671725-e2a81cda3436?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxlbmdpbmVlciUyMHNvbGFyJTIwZW5lcmd5JTIwcm9vZnxlbnwwfHx8fDE3ODg4OTEyOTZ8MA&ixlib=rb-4.1.0&q=85",
  modernHome:
    "https://images.unsplash.com/photo-1750498406418-9b1c5c571b5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMHNvbGFyJTIwcG93ZXIlMjBncmVlbiUyMG5hdHVyZXxlbnwwfHx8fDE3ODg4OTEyODV8MA&ixlib=rb-4.1.0&q=85",
};

export const buildWhatsAppMessage = ({ nome, telefone, cidade, valorConta }) =>
  `Olá HB Solar Energia! Gostaria de solicitar um orçamento gratuito.\n\n*Nome:* ${nome}\n*Telefone:* ${telefone}\n*Cidade:* ${cidade}\n*Valor médio da conta de luz:* R$ ${valorConta}\n\nVim pelo site ${DOMAIN}`;

export const openWhatsApp = (message) =>
  window.open(`${WHATSAPP_LINK}?text=${encodeURIComponent(message)}`, "_blank");
